<template>
  <AnonymousCallMain />
</template>
<script>
import AnonymousCallMain from '@/components/AnonymousCall/main.vue';
export default {
  name: 'AnonymousCall',
  components: {
    AnonymousCallMain
  },
  props: {},
  data() {
    return {};
  },
  beforeRouteLeave(to, from, next) {
    if (to.path != '/' && to.name != 'AnonymousCalling') {
      window.open(to.fullPath, '_blank');
      next(false);
    } else {
      next(true);
    }
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
